export enum ROUTES_MANAGER {
    PROVIDER_REPORTS = 'provider-reports',
    CAMPAINGS = 'campaings'
}
